(function ($, Promise) {

    // Constructor
    function VICCAbout() {
      // console.log("VICCAbout: constructor()");

      this.share = new VICCVisualizeShare();
    }

    VICCAbout.prototype.attach = function (dom) {
      // console.log("VICCAbout: attach()");

      this.selectedDisaster = "flood";

      this.share.attach();
      this.initTrigger();
    }

    VICCAbout.prototype.initTrigger = function () {
      // Scroll to content using nav
      $("#science #sidebar-menu a[href]").off("click").on("click", $.proxy(function (e) {
        if ($(e.target).attr("href") == "#visualize-process") {
          // Trigger disaster using sidemenu
          $("#sidebar-menu a[href^='#']").removeClass("active selected");
          $(e.target).addClass("active selected");

          $("#visualize-process-container .disaster-selector li[data-disaster='" + $(e.target).data("disaster") + "']").trigger("click");
        }
      }, this));

      // Change disaster
      $("#visualize-process-container .disaster-selector li").on("click", $.proxy(function (e) {
        var selectedDisaster = $(e.currentTarget).data("disaster");
        this.selectedDisaster = selectedDisaster;

        $("#science").attr("data-disaster", selectedDisaster);

        $(e.currentTarget).addClass("current").siblings().removeClass("current");

        // Restart/Play animation
        if (window.viewport().width >= 768) {
          $.each(Object.keys(app.components.anim.processStepTimelines), $.proxy(function (index, el) {
            if (el == selectedDisaster) {
              app.components.anim.processStepTimelines[selectedDisaster].restart().play();
            } else {
              app.components.anim.processStepTimelines[el].pause().restart();
            }
          }, this));
        } else {
          // Update div height
          gsap.to("#visualize-process-container .visualize-process", 0.5, {
            height: $("#visualize-process-container .process-" + selectedDisaster).outerHeight(),
          });
        }
      }, this));
    }

    VICCAbout.prototype.dettach = function () {
      // console.log("VICCAbout: dettach()");
    }

    // Expose VICCAbout
    window.VICCAbout = VICCAbout;

  }
)
(jQuery, Promise);
